import { apiJSON, apiVoid } from './http'
import type { AccountSummary } from './types'
import type { PlatformCapabilities } from './platforms'

export interface LocalUser {
  id: string
  email: string
}

export interface ConnectedPlatform {
  attachmentId: string
  platformId: string
  displayName: string
  capabilities: PlatformCapabilities | null
}

export interface ConnectionState {
  platforms: ConnectedPlatform[]
  accountId: string | null
  accounts: AccountSummary[]
  capabilities: PlatformCapabilities | null
}

export interface AttachedPlatform {
  id: string
  platformId: string
  displayName: string
  createdAt: string
  updatedAt: string
}

export interface SessionResponse {
  authenticated: boolean
  vaultUnlocked: boolean
  firstRun?: boolean
  user: LocalUser | null
  attached: AttachedPlatform[]
  connection: ConnectionState | null
}

export function getSession(): Promise<SessionResponse> {
  return apiJSON<SessionResponse>('/api/auth/session')
}

export function register(email: string, password: string): Promise<SessionResponse> {
  return apiJSON<SessionResponse>('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  })
}

export function login(email: string, password: string): Promise<SessionResponse> {
  return apiJSON<SessionResponse>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  })
}

export function logout(): Promise<void> {
  return apiVoid('/api/auth/logout', { method: 'POST' })
}

export function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  return apiVoid('/api/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({ currentPassword, newPassword }),
  })
}
